import { SUBSCRIPTIONS } from '@/app/modules/subscriptions/api/apiUrls';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import subscriptionFields from '@/app/modules/subscriptions/fields/subscriptionFields';

const mutationMultiplePosActivation = (onSuccess, onError) => {
    return {
        mutationFn: ({ subscriptionsIds, planId }) => {
            return client.post(SUBSCRIPTIONS.ACTIVATE_MULTI.url, {
                [subscriptionFields.SUBSCRIPTIONS.key]: subscriptionsIds,
                [subscriptionFields.SUBSCRIPTION_PLAN.key]: planId
            });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationMultiplePosActivation;